(function () {
  const CENTRAL_TIME_ZONE = 'America/Chicago';
  const SAME_DAY_CUTOFF_HOUR = 13;

  function centralParts(date) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: CENTRAL_TIME_ZONE,
      weekday: 'short',
      hour: 'numeric',
      hourCycle: 'h23'
    });
    return formatter.formatToParts(date).reduce((parts, part) => {
      parts[part.type] = part.value;
      return parts;
    }, {});
  }

  function shipsToday(date) {
    const parts = centralParts(date);
    return parts.weekday !== 'Sat' && parts.weekday !== 'Sun' && Number(parts.hour) < SAME_DAY_CUTOFF_HOUR;
  }

  function nextShippingText(date) {
    const parts = centralParts(date);
    if (shipsToday(date)) return 'today.';
    if (parts.weekday === 'Fri' || parts.weekday === 'Sat' || parts.weekday === 'Sun') return 'Monday.';
    return 'tomorrow.';
  }

  function updateShippingMessages() {
    const now = new Date();
    document.querySelectorAll('[data-cd-shipping-message]').forEach((message) => {
      const timing = message.querySelector('[data-cd-shipping-timing]');
      if (!timing) return;
      timing.textContent = nextShippingText(now);
      message.setAttribute('aria-label', `This item ships ${timing.textContent}`);
      message.setAttribute('title', 'Orders placed before 1 PM CT typically ship the same business day. Weekend orders ship the next business day.');
      message.hidden = false;
    });
  }

  function initializeGalleryPagination(root = document) {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.cdPaginationReady === 'true') return;
      const slider = gallery.querySelector('.product__media-list');
      const dots = Array.from(gallery.querySelectorAll('.slider-pagination-dots .pagination-dot'));
      const slides = Array.from(gallery.querySelectorAll('.product__media-list .product__media-item'));
      if (!slider || dots.length < 2 || slides.length < 2) return;

      const setActive = (index) => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          setActive(index);
        });
      });

      let scrollFrame;
      slider.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const index = Math.round(slider.scrollLeft / Math.max(slider.clientWidth, 1));
          setActive(Math.max(0, Math.min(index, dots.length - 1)));
        });
      }, { passive: true });

      gallery.dataset.cdPaginationReady = 'true';
    });
  }

  function initializeProductPage(root = document) {
    updateShippingMessages();
    initializeGalleryPagination(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProductPage());
  } else {
    initializeProductPage();
  }

  document.addEventListener('shopify:section:load', (event) => initializeProductPage(event.target));
})();
